import { useState } from 'react';

// Um "ⓘ" que abre uma frase curta ao toque — sem modal, sem sair da tela.
export default function Info({
  texto,
  alinharDireita = false,
}: {
  texto: string;
  alinharDireita?: boolean;
}) {
  const [aberto, setAberto] = useState(false);
  return (
    <span className="relative inline-flex align-middle">
      <button
        type="button"
        onClick={() => setAberto((a) => !a)}
        aria-label="Mais informação"
        aria-expanded={aberto}
        className="flex h-5 w-5 cursor-pointer items-center justify-center rounded-full text-foreground-400 transition-colors hover:text-foreground-700"
      >
        <i className="ri-information-line text-base" />
      </button>
      {aberto && (
        <span
          className={`absolute top-6 z-20 w-56 rounded-xl border border-secondary-200 bg-white px-3 py-2 text-left text-[12px] font-normal leading-snug text-foreground-700 shadow-lg ${
            alinharDireita ? 'right-0' : 'left-0'
          }`}
        >
          {texto}
        </span>
      )}
    </span>
  );
}